<template>
  <div class="psychological-age-page">
    <!-- 背景图片，沿用 HealthService 风格 -->
    <img class="page-bg" src="/images/backgrounds/home-bg.png" alt="背景" />

    <!-- Logo -->
    <img class="page-logo" :src="logoImage" alt="Logo"/>

    <!-- 返回按钮 -->
     <img class="page-back-btn"  @click="onHeaderBtnClick" :src="backButtonImage" alt="返回"/>

    <!-- 内容区域，沿用 HealthService 的 content-box 位置 -->
    <div class="content-box">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 生理年龄模块 -->
      <div v-else class="service-section age-section">
       <div class="baige">
        <!-- 模块标题：生理年龄 -->
        <div class="bodyMass-title">检测结果
          <!-- <div class="bodyMass-div"></div> -->
        </div>

        <!-- 年龄对比卡片 -->
        <div class="age-compare-card">
          <img
              class="age-compare-bg-img"
              src="/images/backgrounds/age-compare.png"
              alt="年龄对比背景"
          />
          <div class="age-compare-content">
            <div class="age-item age-left">
              <div class="age-value">{{ psychologicalAgeDisplay }}</div>
              <div class="age-label">实际年龄</div>
            </div>
            <div class="age-divider"></div>
            <div class="age-item age-right">
              <div class="age-value">{{ physiologicalAgeDisplay }}</div>
              <div class="age-label">生理年龄</div>
            </div>
          </div>
        </div>

        <!-- 身体年龄趋势标题 + 图例 -->
        <div class="trend-header">
          <div class="trend-header-left">
            <span class="trend-icon">
              <img
                  src="/images/icons/age-trend.png"
                  alt="身体年龄趋势"
              />
            </span>
            <span class="trend-title">身体年龄趋势</span>
          </div>
          <div class="trend-legend">
            <span class="legend-item">
              <span class="legend-color legend-young"></span>年轻
            </span>
            <span class="legend-item">
              <span class="legend-color legend-normal"></span>正常
            </span>
            <span class="legend-item">
              <span class="legend-color legend-old"></span>衰老
            </span>
            <span class="legend-item legend-age-line">— 年龄</span>
          </div>
        </div>

        <!-- 图表卡片 -->
        <div class="chart-card">
          <Chart :option="chartOption" height="360px" />
        </div>

        <!-- 文本说明 -->
        <div class="description-card">
          <p>
            生理年龄指基于身体结构和功能的实际状态评估的年龄，反映器官、细胞、代谢等方面的健康程度和衰老水平。
          </p>

        </div>
       </div>  
      </div>

      <!-- 无数据状态 -->
      <div v-if="!loading && !ageData" class="empty-state">
        暂无数据
      </div>

      <!-- 底部间距 -->
      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
import Chart from '@/components/common/Chart.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'PsychologicalAge',
  components: {
    Chart
  },
  data () {
    return {
      loading: false,
      ageData: {},
      logoImage: '/images/backgrounds/title2.png',
      backButtonImage: '/images/home/header-back@1x.png',
    }
  },
  computed: {
        // 直接映射getter
    ...mapGetters('user', ['userId', 'userInfo']),
    
    // 或者自定义名称
    currentUserId() {
      return this.$store.getters['user/userId']
    },
    currentUserInfo() {
      return this.$store.getters['user/userInfo']
    },
    psychologicalAgeDisplay () {
      return this.ageData && this.ageData.psychologicalAge != null
          ? this.ageData.psychologicalAge
          : '--'
    },
    physiologicalAgeDisplay () {
      return this.ageData && this.ageData.physiologicalAge != null
          ? this.ageData.physiologicalAge
          : '--'
    },
    chartOption () {
      if (!this.ageData || !this.ageData.systemAges || !this.ageData.systemAges.length) {
        return {}
      }
      const systems = this.ageData.systemAges.map(item => item.systemName)
      const ages = this.ageData.systemAges.map(item => item.age)

      const minAge = Math.min.apply(null, ages)
      const maxAge = Math.max.apply(null, ages)
      const padding = 2
      const yMin = Math.floor(minAge - padding)
      const yMax = Math.ceil(maxAge + padding)
      const splitNumber = 4

      // 控制 x 轴最多显示的标签数量（至多显示 maxXLabels 个）
      const maxXLabels = 5
      const step = Math.ceil(systems.length / maxXLabels)
      const labelInterval = Math.max(0, step - 1)

      const pointColors = ages.map(age => {
        if (age < this.psychologicalAgeDisplay - 2) return '#FFA726'
        if (age <= this.psychologicalAgeDisplay + 2) return '#4CAF50'
        return '#1E88E5'
      })
      const seriesData = ages.map((v, i) => ({
        value: v,
        itemStyle: { color: pointColors[i] },
        emphasis: {
          itemStyle: {
            color: pointColors[i]
          }
        },
        label: {
          show: true,
          position: 'top',
          formatter: params => {
            return params.data && typeof params.data === 'object' 
              ? params.data.value 
              : params.value
          },
          color: pointColors[i],
          fontSize: 12,
          fontWeight: 'bold'
        }
      }))

      return {
        backgroundColor: '#FFFFFF',
        pointColors, // 将pointColors数组添加到图表选项中
        tooltip: {
          trigger: 'axis',
          formatter (params) {
            if (!params || !params.length) return ''
            const p = params[0]
            const value = p.data && typeof p.data === 'object' ? p.data.value : p.value
            return `${p.axisValue}<br/>年龄：${value} 岁`
          },
          axisPointer: {
            type: 'line',
            lineStyle: { color: '#B0BEC5' }
          }
        },
        grid: {
          left: '10%',
          right: '6%',
          top: '12%',
          bottom: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: systems,
          boundaryGap: false,
          axisLine: {
            lineStyle: { color: '#CFD8DC' }
          },
          axisTick: { show: false },
          axisLabel: {
            // 使用计算出的间隔，确保标签不超过 maxXLabels 个
            rotate: 45,
            color: '#546E7A',
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          min: yMin,
          max: yMax,
          splitNumber,
          name: '年龄',
          nameTextStyle: {
            color: '#90A4AE',
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#90A4AE',
            fontSize: 12
          }
        },
        series: [
          {
            name: '年龄',
            type: 'line',
            data: seriesData,
            smooth: true,
            symbolSize: 7,
            lineStyle: {
              color: '#B0BEC5',
              width: 2
            },
            areaStyle: {
              color: 'rgba(187, 222, 251, 0.4)'
            },
            label: {
              show: false, // 完全禁用全局的label配置
              color: '#000' // 设置默认颜色
            }
          }
        ]
      }
    }
  },
  async created () {
    await this.loadAgeData()
  },
  methods: {
    ...mapActions('report', ['fetchPhysiologicalAgeData']),
    async loadAgeData () {
      this.loading = true
      const userId = this.$route.query.userId
      if (!userId) {
        this.loading = false
        return
      }
      try {
        const raw = await this.fetchPhysiologicalAgeData({ userId })
        console.log('raw physiological age data =>', raw)

        if (!raw) {
          this.ageData = {
            psychologicalAge: 29,
            physiologicalAge: 30,
            systemAges: [
              { systemName: '心脑血管', age: 28 },
              { systemName: '肠胃', age: 30 },
              { systemName: '肝胆', age: 36 },
              { systemName: '肾脏', age: 30 },
              { systemName: '呼吸', age: 30 },
              { systemName: '内分泌', age: 30 },
              { systemName: '免疫', age: 26 },
              { systemName: '骨骼', age: 25 },
              { systemName: '性别相关', age: 25 },
              { systemName: '性功能', age: 25 }
            ]
          }
          return
        }
      console.log('用户信息:', this.$store.getters['user/userInfo'])
      let gender = this.$store.getters['user/userInfo'].sex
        // 获取用户性别信息
        const converted = {
          psychologicalAge: raw.age,
          physiologicalAge: raw.physiologicalAge,
          systemAges: [
            { systemName: '心脑血管', age: raw.bloodVessel },
            { systemName: '肠胃', age: raw.stomach },
            { systemName: '肝胆', age: raw.hepatobiliary },
            { systemName: '肾脏', age: raw.kidney },
            { systemName: '呼吸', age: raw.breathing },
            { systemName: '内分泌', age: raw.endocrine },
            { systemName: '免疫', age: raw.immune },
            { systemName: '骨骼', age: raw.bones },
            { systemName: gender === 1 ? '阴囊' : gender === 2 ? '乳腺' : '', age: raw.male },
            { systemName: '性别综合', age: raw.sex }
          ].filter(item => item.age != null)
        }

        this.ageData = converted
      } catch (error) {
        console.error('Failed to load age data:', error)
      } finally {
        this.loading = false
      }
    },
    onHeaderBtnClick () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.psychological-age-page {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* 背景图片，沿用 HealthService 风格 */
.page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

// Logo
.page-logo {
  position: absolute;
  left: 40rpx;
  top: 50rpx;
  width: 315.6rpx;
  height: 100rpx;
  z-index: 2;
}

// 返回按钮
.page-back-btn {
  position: absolute;
  left: 495rpx;
  top: 65rpx;
  width: 220rpx;
  height: 70rpx;
  border-radius: 10rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6rpx;
  box-sizing: border-box;
  border: 1px solid #FFFFFF;
}
/* 内容区域，与 HealthService 的 content-box 一致 */
.content-box {
  position: absolute;
  left: 36rpx;
  top: 154rpx;
  width: 677rpx;
  z-index: 1;
}
.bodyMass-title {
  position: relative;
  left: 18.7rpx;
  top: 18.7rpx;    
  // height: 52px;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 6;
}

.bodyMass-div{
  position: absolute;
  left: 0px;
  top: 30.7rpx;
width: 140rpx;
height: 9.34rpx;
z-index: -1;
/* 主色 */
background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
	
}

/* 加载状态 */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80rpx 40rpx;
  min-height: 400rpx;

  .loading-spinner {
    width: 80rpx;
    height: 80rpx;
    border: 8rpx solid #f3f3f3;
    border-top: 8rpx solid #0E6EB8;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    margin-top: 32rpx;
    font-size: 28rpx;
    color: #666;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.baige{
  width: 654rpx;
  background-color: #fff;
  border-radius: 20rpx;
  padding-bottom: 30rpx;
}
/* 服务模块容器，沿用 HealthService 的 service-section 风格 */
.service-section {
  position: relative;
  margin-top: 31.25rpx;
  width: 677rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
  z-index: 2;
}

/* 模块标题 */
.section-title {
  position: relative;
  left: 0;
  top: 0;
  width: 177rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);
}

/* 年龄对比卡片，作为模块内的一张卡 */
.age-compare-card {
  position: relative;
  left: 46.875rpx;
  margin-top: 30rpx;
  width: 583.3rpx;
  height: 156rpx;
  border-radius: 20rpx;
  overflow: hidden;
}

.age-compare-bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.age-compare-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: stretch;
  padding: 24rpx 0;
}

.age-item {
  flex: 1;
  text-align: center;
}

.age-left .age-value {
  color: #90bb55;
}

.age-right .age-value {
  color: #0e6eb8;
}

.age-divider {
  width: 20rpx;
}

/* 年龄文字 */
.age-value {
  font-size: 50rpx;
  font-weight: 700;
  line-height: 1.2;
}

.age-label {
  margin-top: 8rpx;
  font-size: 20rpx;
  color: #90bb55;
}

.age-right .age-label {
  color: #0e6eb8;
}

/* 趋势标题 + 图例（放在模块中间） */
.trend-header {
  position: relative;
  left: 46.875rpx;
  margin-top: 26rpx;
  width: 583.3rpx;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trend-header-left {
  display: flex;
  align-items: center;
}

.trend-icon {
  width: 44rpx;
  height: 44rpx;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8rpx;
}

.trend-title {
  font-size: 30rpx;
  font-weight: 600;
  color: #333333;
}

.trend-legend {
  display: flex;
  align-items: center;
  font-size: 20rpx;
  color: #666666;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 16rpx;
  margin-left: 16rpx;
}

.legend-color {
  display: inline-block;
  width: 24rpx;
  height: 24rpx;
  border-radius: 4rpx;
  margin-right: 8rpx;
}

.legend-young {
  background: #ffa726;
}

.legend-normal {
  background: #4caf50;
}

.legend-old {
  background: #90caf9;
}

.legend-age-line {
  color: #333333;
}

/* 图表容器：整体放在模块内 */
.chart-card {
  position: relative;
  left: 46.875rpx;
  margin-top: 20.8rpx;
  width: 583.3rpx;
}

/* 文本说明卡片 */
.description-card {
  position: relative;
  left: 46.875rpx;
  margin-top: 26rpx;
  width: 583.3rpx;
  min-height: 80rpx;
  border-radius: 10.4rpx;
  padding: 20.8rpx 15.625rpx;
  background: #F8F8F8;
  color: #455a64;
  font-size: 24rpx;
  line-height: 1.7;
}

/* 无数据 */
.empty-state {
  margin-top: 40rpx;
  text-align: center;
  color: #90a4ae;
  font-size: 26rpx;
}

/* 底部间距 */
.bottom-spacer {
  height: 50rpx;
  position: relative;
}
</style>
